import {
  createAction,
  createAsyncThunk,
  createSelector,
  createSlice,
  injectSlice,
} from '@betty/toolkit/state';

import LandingPromoService from '../../services/LandingPromoService';
import { LandingPromosState } from './landingPromos.types';
import { generateSlug } from '@betty/toolkit/utils';

export const fetchPromo = createAction('landingPromo/fetch-promos');

export const getPromo = createAsyncThunk(
  'landingPromo/fetch-promos',
  async () => {
    const { promotions } = await LandingPromoService.getLandingPromos();

    const landingPromos = promotions.map((promo) => ({
      ...promo,
      slug: generateSlug(promo.title),
    }));

    return landingPromos;
  },
);

const initialState: LandingPromosState = {
  data: [],
  dataState: 'idle',
  isClaimPromoButtonVisible: false,
};

const landingPromo = createSlice({
  name: 'withLandingPromo',
  initialState,
  reducers: {
    setClaimPromoButtonVisibility(state, action) {
      state.isClaimPromoButtonVisible = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getPromo.fulfilled, (state, action) => {
      state.dataState = 'fulfilled';
      state.data = action.payload;
    });
    builder.addCase(getPromo.pending, (state) => {
      if (state.dataState !== 'fulfilled') {
        state.dataState = 'pending';
      }
    });
    builder.addCase(getPromo.rejected, (state) => {
      state.dataState = 'rejected';
    });
  },
});

export const { setClaimPromoButtonVisibility } = landingPromo.actions;

export const withLandingPromo = injectSlice({
  reducerPath: 'landingPromo',
  reducer: landingPromo.reducer,
});

export const selectIsClaimPromoButtonVisible = withLandingPromo.selector(
  (state) => state.landingPromo.isClaimPromoButtonVisible,
);

export const selectLandingPromos = withLandingPromo.selector(
  (state) => state.landingPromo.data,
);

export const selectLandingPromosDataState = withLandingPromo.selector(
  (state) => state.landingPromo.dataState,
);

export const selectLandingPromoByType = (promoType?: string) =>
  createSelector(selectLandingPromos, (promos) =>
    promos.find((promo) => promo.promoType === promoType),
  );

declare global {
  interface LazyLoadedSlices {
    landingPromo: ReturnType<typeof landingPromo.reducer>;
  }
}
